// $("#contact_form").on("submit", function (e) {
//     e.preventDefault()
// 	console.log("submitting");
// 	$(".newsletter-form__sign-up").attr("disabled", true);
// 	$.ajax({
// 		url: $("#contact_form").attr("action"),
// 		method: "POST",
// 		data: $("#contact_form").serialize(),
// 		success: function () {
// 			Swal.fire({
// 				icon: "success",
// 				title: "Thanks for reaching out! A member of our team will be in touch with you shortly.",
// 				width: 500,
// 			});
// 			$("#contact_form").trigger("reset");
// 		},
// 	});
// 	$(".newsletter-form__sign-up").attr("disabled", false);
// 	return false;
// });

document.querySelectorAll("#form_contact").forEach((form) => {
	form.addEventListener("submit", function (e) {
		e.preventDefault();
		$.ajax({
			url: $(this).attr("action"),
			method: "POST",
			data: $("#form_contact").serialize(),
			success: function (responce) {
                console.log(1, responce);
				$("#form_contact").hide();
				Swal.fire({
					title: "Thanks for getting in touch! Our LVLY customer service team will be in touch soon - we aim to respond to all enquiries within 24 hours",
					width: 500,
					confirmButtonColor: "#ee4382",
				});
				$("#form_contact .contact_email").val("");
			},
			error: function (errorData) {
              console.log(2, errorData);
				Swal.fire({
					// icon: "error",
					title: "Oops!",
					width: 500,
					text: "Oh no, something went wrong. Please try again or contact us at <a href='mailto:hello@lvly.com.au'><strong>hello@lvly.com.au</strong></a> for assistance",
					confirmButtonColor: "#ee4382",
				});
				$("#form_contact .contact_email").val("");
			},
		});
		return false;
	});
});

document.querySelectorAll("#contact_form").forEach((form) => {
	form.addEventListener("submit", function (e) {
		e.preventDefault();
		$.ajax({
			url: $(this).attr("action"),
			method: "POST",
			data: $("#contact_form").serialize(),
			success: function (responce) {
                console.log(1, responce);
				Swal.fire({
					// title: "You are so LVLY",
					text: "Thanks! You're a LVLY VIP.",
					width: 500,
					confirmButtonColor: "#ee4382",
				});
				$("#contact_form .contact_email").val("");
			},
			error: function (errorData) {
              console.log(2, errorData);
				Swal.fire({
					title: "Oops!",
					width: 500,
					text: "Oh no, something went wrong. Please try again or contact us at <a href='mailto:hello@lvly.com.au'><strong>hello@lvly.com.au</strong></a> for assistance",
					confirmButtonColor: "#ee4382",
				});
				$("#contact_form .contact_email").val("");
			},
		});
		return false;
	});
	// Swal.fire({
	// 	// title: "You are so LVLY",
	// 	text: "Thanks! You're a LVLY VIP.",
	// 	width: 500,
	// 	confirmButtonColor: "#ee4382",
	// });
});
